export default __webpack_public_path__ + "static/media/Bcoin.788d19fc.svg";